import { OnboardingStepperSideMenu } from '../../_layout/OnboardingStepperSideMenu'

function PendingApprovalPageSideMenu() {
  return <OnboardingStepperSideMenu />
}

export { PendingApprovalPageSideMenu }
